// extracted by mini-css-extract-plugin
var _1 = "aaiqR";
export { _1 as "table" }
